import React, { useEffect, useState } from 'react';
import PrivatePage from '../../base/private';
import { Container, makeStyles, Paper, IconButton, Grid, Button} from '@material-ui/core';
//import Loader from '../../../components/loader';
//import useFetch from '../../../hooks/useFetch';
import { COLORS } from '../../../constants/colors';
import Section from '../../../components/common/section';
import { faEye, faEdit, faSearch, faClone,faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DataGrid } from '@material-ui/data-grid';
import _ from 'lodash';
import Input from '../../../components/common/input';
import useDebounce from '../../../hooks/useDebounce';
import useNotification from '../../../hooks/useNotification';
import { fetchCandidates, cloneCandidate } from '../../../api/candidate';
import { useHistory } from 'react-router';
import { REACT_APP_FULLSEARCH_ONLY } from '../../../config';
import { fetchCandidateCV } from '../../../api/pdf';

const useStyles = makeStyles({
  root: {
    '& .grey--header': {
      backgroundColor: COLORS.grayScale[4],
    },
    '& .action-cell': {
      justifyContent: 'center'
    }
  },
  container: {
    maxWidth: '90rem',
    padding: '2rem 3.125rem',
  },
  loader: {
    paddingTop: '3rem',
  },
  cellButton: {
    justifyContent: 'center'
  },
  filterContainer: {
    marginBottom: '2.0625rem'
  }
});

function getFullName(params) {
  // return `${params.getValue('firstName') || ''} ${
  //   params.getValue('lastName') || ''
  // }`;
  return `${params?.row?.firstName ?? ''} ${params?.row?.lastName ?? ''}`;
}

function getPosition(params) {
  //return `${params.getValue('role')?.name || ''}`;
  return `${params?.row?.role?.name ?? ''}`;
}

const CandidatesPage = () => {
  const classes = useStyles();
  const [ results, setResults ] = useState([]);
  const [ searchName, setSearchName ] = useState('');
  const [ searchPosition, setSearchPosition ] = useState('');
  const [ searchFull, setSearchFull] = useState('');
  const [ isLoading, setIsLoading ] = useState(false);
  const [ page, setPage ] = useState(0);
  const history = useHistory();
  const notifications = useNotification();

  const handleAdd = () => {
    history.push(`/candidates/add`);
  }
  
  const goToEdit = (hash) => {
    history.push(`/candidates/${hash}/edit`);
  }
  
  const downloadPDF = (data) => {
    return fetchCandidateCV(data?.hash)
    .ready()
    .then((res) => {
      if (res.success){
        const blob = new Blob([res.data], {type: 'application/pdf'})
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `Resume - ${data?.firstName} ${data?.lastName}.pdf`
        link.click()
      }else{
        notifications.error({ message: 'An error has occured while downloading candidate CV. Please, try again later', });
      }
    })
  }

  const goToClone = useDebounce(
    (hash) => {
      setIsLoading(true);
      return cloneCandidate(hash)
            .ready()
            .then((res) => {
              if (res.success){ 
                setSearchName(`${res.data.firstName}${res.data.lastName}`.slice(0, -7));
                notifications.success({ message: `Candidate has been copied: ${res.data.firstName} ${res.data.lastName}`, });
              }else
                notifications.error({ message: 'An error has occured while cloning candidate. Please, try again later', });
            })
            .finally(() => {
              setIsLoading(false);
            });
    },
    1000
  );
  

  const columns = [
    {
      field: 'fullName', 
      headerName: 'Name', 
      headerClassName: 'grey--header', 
      flex: 0.5,
      valueGetter: getFullName,
      sortComparator: (v1, v2, cellParams1, cellParams2) => getFullName(cellParams1).localeCompare(getFullName(cellParams2))
    },
    {
      field: 'position', 
      headerName: 'Position', 
      headerClassName: 'grey--header', 
      flex: 1,
      valueGetter: getPosition, 
      sortComparator: (v1, v2, cellParams1, cellParams2) => getPosition(cellParams1).localeCompare(getPosition(cellParams2))
    },
    {
      field: 'view',
      headerName: 'View',
      headerClassName: 'grey--header',
      cellClassName: 'action-cell',
      headerAlign: 'center',
      sortable: false,
      flex: 0.2,
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() =>history.push(`/candidates/${params.row?.hash}`)}
            color="primary"
          >
            <FontAwesomeIcon icon={faEye} title="View" />
          </IconButton>
        )
      },
    },
    {
      field: 'Resume',
      headerName: 'Resume',
      headerClassName: 'grey--header',
      cellClassName: 'action-cell',
      headerAlign: 'center',
      sortable: false,
      flex: 0.2,
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => downloadPDF(params.row)}
            color="primary"
          >
            <FontAwesomeIcon icon={faFilePdf} title="Resume" />
          </IconButton>
        )
      },
    },
    {
      field: 'edit',
      headerName: 'Edit',
      headerClassName: 'grey--header',
      cellClassName: 'action-cell',
      headerAlign: 'center',
      sortable: false,
      flex: 0.2,
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => goToEdit(params.row?.hash)}
            color="primary"
          >
            <FontAwesomeIcon icon={faEdit} title="Edit" />
          </IconButton>
        )
      },
    },
    {
      field: 'clone',
      headerName: 'Copy',
      headerClassName: 'grey--header',
      cellClassName: 'action-cell',
      headerAlign: 'center',
      sortable: false,
      flex: 0.2,
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => goToClone(params.row?.hash)}
            color="primary"
          >
            <FontAwesomeIcon icon={faClone} title="Copy" />
          </IconButton>
        )
      },
    },
  ];

  const fetchCandidatesDebounced = useDebounce(
    (name, position, others) => {
      setIsLoading(true);
      setPage(0);
      return fetchCandidates(name, position, others)
            .ready()
            .then((res) => {
              if (res.success) setResults(res.data);
              else
                notifications.error({
                  message:
                    'An error has occured while searching candidate. Please, try again later',
                });
            })
            .finally(() => {
              setIsLoading(false);
            });
    },
    1000
  );

  useEffect(() => {
    fetchCandidatesDebounced(searchName, searchPosition, searchFull);
  }, [searchName, searchPosition, searchFull]);

  return (
    <PrivatePage>
        <div className={classes.root}>
          <section>
            <Container className={classes.container}>
              <Section title="Candidates">
                <section>
                  <Grid container direction="row" className={classes.filterContainer} spacing={2}>
                    { !REACT_APP_FULLSEARCH_ONLY && <>
                      <Grid item xs={3}>
                      <div className={classes.searcher}>
                        <Input
                          value={searchName}
                          startIcon={<FontAwesomeIcon icon={faSearch} />}
                          placeholder="Search by name"
                          onChange={({ target }) => setSearchName(target.value)}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={3}>
                      <div className={classes.searcher}>
                        <Input
                          value={searchPosition}
                          startIcon={<FontAwesomeIcon icon={faSearch} />}
                          placeholder="Search by position"
                          onChange={({ target }) => setSearchPosition(target.value)}
                        />
                      </div>
                    </Grid>
                    </>}
                    <Grid item xs={3}>
                      <div className={classes.searcher}>
                        <Input
                          value={searchFull}
                          startIcon={<FontAwesomeIcon icon={faSearch} />}
                          placeholder={REACT_APP_FULLSEARCH_ONLY ? 'Full Search':'Search others'}
                          onChange={({ target }) => setSearchFull(target.value)}
                        />
                      </div>
                    </Grid>
                    <Grid item style={{ textAlign: 'right' }} xs>
                      <Button variant="contained" color="primary" onClick={() => handleAdd()}>ADD CANDIDATE</Button>
                    </Grid>
                  </Grid>
                </section>
                <Paper>
                  <div>
                    <DataGrid
                      loading={isLoading}
                      rows={results??[]}
                      columns={columns??[]}
                      page={page}
                      onPageChange={(val)=>setPage(val.page)}
                      pageSize={10}
                      autoHeight
                      disableColumnMenu={true}
                      disableSelectionOnClick={true}
                    />
                  </div>
                </Paper>
              </Section>
            </Container>
          </section>
        </div>
    </PrivatePage>
  );
};

export default CandidatesPage;
